import { render, staticRenderFns } from "./PresentationListMenu.vue?vue&type=template&id=6df669c6&scoped=true&"
import script from "./PresentationListMenu.vue?vue&type=script&lang=js&"
export * from "./PresentationListMenu.vue?vue&type=script&lang=js&"
import style0 from "./PresentationListMenu.vue?vue&type=style&index=0&id=6df669c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df669c6",
  null
  
)

export default component.exports